/*
 * 贷款客户管理页面 (一级页面)
 *
 * entityKey: mortgageLoan/leadList -> GET /api/mis/mortgageLoan/leadList
 * Controller: MortgageLoanController.leadList (menuType="1")
 * Service: MortgageLoanServiceImpl.queryMortgageLoanStatPage
 * Mapper: MortgageLoanMapper.queryMortgageLoanStatPage (GROUP BY lead_id)
 *
 * 主要功能:
 *  1. 客户级别的贷款汇总展示 (每行 = 一个客户)
 *  2. 顶部统计栏 (调用 /mortgageLoan/leadListSum)
 *  3. 新增贷款弹窗 (POST /mortgageLoan/batchCreate)
 *  4. 释放客户 (打开新窗口 /#/releaseLead)
 *  5. 坏账标记 (POST /mortgageLoan/updateLeadLoanStatus)
 *  6. 利率设置 (POST /mortgageLoan/saveInterest)
 *  7. 查询日期管理 (POST /mortgageLoan/saveAndUpdateExtra, optType=queryTime)
 *  8. 征信打印日期管理 (POST /mortgageLoan/saveAndUpdateExtra, optType=creditPrintTime)
 *  9. 客户信息更新 (POST /mortgageLoan/saveAndUpdateExtra, optType=loanAt)
 *  10. 删除客户所有贷款 (DELETE /mortgageLoan/deleteByLeadId/{leadId})
 *  11. 还款计划查看 (弹窗内嵌 RepaymentPlan 组件)
 *  12. 贷款详情查看 (打开新窗口 /#/newleadLoan)
 */
import {
  Col,
  ColType,
  Crud,
  CrudAction,
  CrudApi,
  CrudOption,
} from "../../comp/crud";
import {
  ApiClient,
  getLeadStatItemOpt,
  getMortgageLoanStatusOpt,
  Lead,
} from "../../api/ApiClient";
import React, { useEffect, useState } from "react";
import {
  ArrayField,
  Button,
  Descriptions,
  Form,
  Modal,
  Popover,
  Row,
  Col as RowCol,
  Tag,
  Toast,
  Tooltip,
  Typography,
} from "@douyinfe/semi-ui";
import RepaymentPlan from "./repaymentPlan";
import AddLoanModal from "./components/AddLoanModal";
import OutMoneyPlan from "./indexOutMoneyPlan";
import {
  IconCalendarClock,
  IconHelpCircle,
  IconMinusCircle,
  IconModalStroked,
  IconMonitorStroked,
  IconPlusCircle,
  IconBarChartHStroked,
} from "@douyinfe/semi-icons";
//import IndexMortgageLoan from "./indexMortgageLoan";
import {
  formatAmountZhCn,
  formatDate,
  formatDateTime,
  renderStatDetailContent,
  renderRepaymentCountTooltip,
  renderOutMoneyAmountTooltip,
  renderRepaymentProgressTooltip,
  renderLoanCountTooltip,
  splitStr,
  renderLoanStatusTag,
} from "../../utils";
import { FormApi } from "@douyinfe/semi-ui/lib/es/form";
import "./mortgage.css";

let apiClient = ApiClient.getDefault();
const { Text } = Typography;

// 主组件: 贷款客户列表页面
export default function IndexMortgageLead() {
  const [mortgageLoanShow, setMortgageLoanShow] = useState(false);
  const [leadId, setLeadId] = useState(0);
  const [planShow, setPlanShow] = useState(false);
  const [outMoneyPlanShow, setOutMoneyPlanShow] = useState(false);
  const [loanId, setLoanId] = useState(0);
  const [paidType, setPaidType] = useState("all");
  const [crudApi, setCrudApi] = useState(undefined as undefined | CrudApi);
  const [filterFormApi, setFilterFormApi] = useState(
    undefined as undefined | FormApi
  );
  const [showAddLoanModal, setShowAddLoanModal] = useState(false);
  const [preselectedLead, setPreselectedLead] = useState(undefined as undefined | Lead);
  const username = localStorage.getItem("username");
  const role = localStorage.getItem("role");
  const [queryTimes, setQueryTimes] = useState([] as any[]);
  const [creditPrintTimes, setCreditPrintTimes] = useState([] as any[]);
  const [saleName, setSaleName] = useState('');
  const [showAddQueryModal, setShowAddQueryModal] = useState(false);
  const [addQueryFormApi, setAddQueryFormApi] = useState(
    undefined as undefined | FormApi
  );
  const [addQuerySaving, setAddQuerySaving] = useState(false);
  const [selectedLead, setSelectedLead] = useState({} as any);
  const [statData, setStatData] = useState([] as any[]);
  const [statDataObj, setStatDataObj] = useState({} as any);
  const [teamMembersTree, setTeamMembersTree] = useState([] as any[]);

  const [showLeadInfoModal, setShowLeadInfoModal] = useState(false);
  const [saveLeadInfoFormApi, setSaveLeadInfoFormApi] = useState(
    undefined as undefined | FormApi
  );
  const [showAddInterestModal, setShowAddInterestModal] = useState(false);
  const [addInterestFormApi, setAddInterestFormApi] = useState(
    undefined as undefined | FormApi
  );

   const [showLoanAtModal, setShowLoanAtModal] = useState(false);
  const [loanAtFormApi, setLoanAtFormApi] = useState(
    undefined as undefined | FormApi
  );
  const [loanAtSaving, setLoanAtSaving] = useState(false);

   const [showAddCreditModal, setShowAddCreditModal] = useState(false);
  const [addCreditFormApi, setAddCreditFormApi] = useState(
    undefined as undefined | FormApi
  );
  const [addCreditSaving, setAddCreditSaving] = useState(false);
  // 列定义: Crud 表格的列配置，包含客户基本信息、贷款汇总金额、状态、查询天数等
  let cols: Col[] = [
    {
      name: "ID",
      key: "id",
      showInFilter: false,
      type: ColType.NUMBER,
      hideInEdit: true,
      hideInList: true,
      hideInCreate: true,
    },
    {
      name: "统计项",
      key: "statType",
      colFilterSort: 0,
      showInFilter: true,
      hideInCreate: true,
      hideInList: true,
      type: ColType.SELECT,
      getOptions: () => Promise.resolve(getMortgageStatTypeItemOpt()),
    },
    {
      name: "客户ID",
      key: "leadId",
      width: 70,
      showInFilter: true,
      type: ColType.NUMBER,
      hideInEdit: true,
      hideInList: true,
    },
    {
      name: "客户姓名",
      key: "leadName",
      width: 80,
      type: ColType.STRING,
      hideInEdit: true,
      hideInCreate: true,
      showInFilter: true,
      render: (value, record, index) => {
        return (
          <Typography.Text
              link
            onClick={() => detailAction(record)}
          >
            {value}({record.leadId})
          </Typography.Text>
        );
      },
    },
    {
      name: "城市",
      key: "leadCity",
      width: 50,
      type: ColType.SELECT,
      getOptions: () => apiClient.getDictAsOpts("city"),
      hideInEdit: true,
      hideInCreate: true,
      showInFilter: true,
    },
    {
      name: "按揭专员ID",
      key: "agentId",
      type: ColType.STRING,
      showInFilter: false,
      hideInList: true,
      hideInCreate: true,
      hideInEdit: true,
    },
    {
      name: "按揭专员",
      key: "agentNames",
      width: 80,
      type: ColType.STRING,
      showInFilter: true,
      hideInCreate: true,
      hideInEdit: true,
    },
    {
      name: "销售ID",
      key: "saleId",
      type: ColType.STRING,
      showInFilter: false,
      hideInList: true,
      hideInCreate: true,
      hideInEdit: true,
    },
    {
      name: "销售",
      key: "saleNames",
      width: 80,
      type: ColType.STRING,
      showInFilter: true,
      hideInCreate: true,
      hideInEdit: true,
    },
    {
      name: "业务属性",
      key: "loanProperty",
      width: 80,
      type: ColType.STRING,
      showInFilter: false,
      hideInCreate: false,
      hideInEdit: false,
    },
    {
      name: "出款人",
      key: "paidUserName",
      type: ColType.STRING,
      showInFilter: false,
      hideInList: true,
      hideInCreate: true,
      hideInEdit: true,
    },
    {
      name: "贷款数",
      key: "totalMortgageCount",
      width: 50,
      type: ColType.NUMBER,
      showInFilter: false,
      hideInCreate: true,
      hideInEdit: true,
      render: (value, record, index) => {
        return (
          <Tooltip style={{maxWidth: 450}} content={renderLoanCountTooltip(record)}>
            <Typography.Text
              link
              onClick={() => {
                openMortgageLoanModal(record.leadId, record.leadName);
              }}
            >
              {value}
            </Typography.Text>
          </Tooltip>
        );
      },
    },
    {
      name: "签约金额",
      key: "totalContractAmount",
      width: 80,
      type: ColType.NUMBER,
      render: (a) => formatAmountZhCn(a),
    },
    {
      name: "贷款金额",
      key: "totalAmount",
      width: 80,
      type: ColType.NUMBER,
      render: (a) => formatAmountZhCn(a),
    },
    {
      name: "计划数",
      key: "repaymentPlanCount",
      width: 50,
      type: ColType.NUMBER,
      showInFilter: false,
      hideInCreate: true,
      hideInEdit: true,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openRepaymentPlanModal(record.leadId, "all");
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      name: "还款数",
      key: "repaymentCount",
      width: 50,
      type: ColType.NUMBER,
      render: (value, record, index) => {
        return (
          <Tooltip style={{maxWidth: 450}} content={renderRepaymentCountTooltip(record)}>
            <Typography.Text
              link
              onClick={() => {
                setLeadId(record.leadId);
                setOutMoneyPlanShow(true);
              }}
            >
              {value ?? 0}
            </Typography.Text>
          </Tooltip>
        );
      },
    },
    {
      name: "还款进度",
      key: "repaymentProgress",
      width: 80,
      type: ColType.TEXT,
      render: (value, record, index) => {
        const done = record.repaymentCount || 0;
        const total = record.repaymentPlanCount || 0;
        const p = total > 0 ? Math.round(done / total * 100) : 0;
        return (
          <Tooltip style={{maxWidth: 450}} content={renderRepaymentProgressTooltip(record)}>
            <Typography.Text style={{ color: p >= 100 ? '#52c41a' : p >= 50 ? '#fa8c16' : '#e91e63', fontWeight: 600 }}>
              {p}%
            </Typography.Text>
          </Tooltip>
        );
      },
    },

    {
                name: "出款金额",
                key: "totalOutMoneyAmount",
                width: 90,
                type: ColType.NUMBER,
                render: (value, record, index) => {
                    return (
                        <Tooltip style={{maxWidth: 600}} content={renderOutMoneyAmountTooltip(record)}>
                            <Typography.Text
                                link
                                onClick={() => {
                                    setLeadId(record.leadId);
                                    setOutMoneyPlanShow(true);
                                }}
                            >
                                {formatAmountZhCn(record.totalHelpPaidAmount+record.totalCardHelpPaidAmount+record.totalBorrowAmount)}
                            </Typography.Text>
                        </Tooltip>
                    );
                },
            },
   
    
    {
      name: "状态",
      key: "status",
      width: 70,
      render: (value, record, index) => renderLoanStatusTag(value, record),
      type: ColType.SELECT,
      showInFilter: true,
      hideInEdit: true,
      hideInCreate: true,
      getOptions: (row) => Promise.resolve(getMortgageLoanStatusOpt()),
    },

    {
      name: "在库时长",
      key: "inStockDays",
      width: 70,
      type: ColType.NUMBER,
    },
    {
      name: "查询天数",
      key: "queryDays",
      width: 70,
      type: ColType.NUMBER,
      render: (value, record, index) => {
       
          return (
            <>
              <Tooltip
                style={{
                  maxWidth: 400,
                  wordBreak: "break-all",
                  whiteSpace: "pre-wrap",
                }}
                content={getLeadVisitAssignLogs(record.queryTimes)}
              >
                {" "}
                <Typography.Text mark>{record.queryDays}</Typography.Text>
                
              </Tooltip>
            </>
          );
        
      },
    },
    {
      name: "征信打印日期",
      key: "creditPrintTime",
      width: 120,
      type: ColType.NUMBER,
      render: (value, record, index) => {
        
          return (
            <>
              <Tooltip
                style={{
                  maxWidth: 400,
                  wordBreak: "break-all",
                  whiteSpace: "pre-wrap",
                }}
                content={getCreditPrintLogs(record.creditPrintTimes)}
              >
                {" "}
                <Typography.Text mark>{!record.creditPrintTimes || record.creditPrintTimes.length == 0
                  ? "":splitStr(record.creditPrintTimes[record.creditPrintTimes.length-1], '|', 1)}</Typography.Text>
       
              </Tooltip>
            </>
          );
        
      },
    },
    {
      name: "接单日期",
      key: "loanAt",
      width: 90,
      type: ColType.DATE_RANGE,
      showInFilter: true,
    },
    {
      name: "日利率",
      key: "interest",
      width: 60,
      type: ColType.STRING,
      render: (value, record, index) => {
                    return (
                        <Tooltip style={{maxWidth: 450}} content={<div>
                            贷款利率: {record.interest }<br/>
                            信用卡利率: {record.borrowInterest}<br/>
                            借款利率: {record.postingInterest }<br/>
                           
                        </div>}>
                            <Typography.Text mark>{value}</Typography.Text>
                        </Tooltip>
                    );
                },
    },
  ];

  // 工具函数: 计算两个日期之间的天数差（不考虑时间部分，使用UTC避免时区影响）
  function getDateDifferenceInDays(startDate: Date, endDate: Date): number {
    // 创建不考虑时间的UTC日期（避免时区影响）
    const utcStart = Date.UTC(
      startDate.getFullYear(),
      startDate.getMonth(),
      startDate.getDate()
    );

    const utcEnd = Date.UTC(
      endDate.getFullYear(),
      endDate.getMonth(),
      endDate.getDate()
    );

    // 计算相差毫秒数并转换为天数
    const diffInMs = Math.abs(utcEnd - utcStart);
    return Math.floor(diffInMs / (1000 * 60 * 60 * 24));
  }

  // 格式化查询日期日志文本，用于 Tooltip 展示每个查询日期及距今天数
  const getLeadVisitAssignLogs = (queryTimes: any) => {
    if (queryTimes) {
      let logText = "";
        queryTimes.forEach((time: any) => {
          let timeStr;
        if(time.includes("|")){
          timeStr = time.split("|")[0];
        }else{
          timeStr = time;
        }
        //计算time到当前时间的天数
        let days = getDateDifferenceInDays(new Date(timeStr), new Date());
        logText = logText + time + "  查询天数:" + days + "\r\n";
      });
      return logText;
    }
  };

  // 格式化征信打印日期日志文本，用于 Tooltip 展示所有打印日期
  const getCreditPrintLogs = (creditPrintTimes: any) => {
    if (creditPrintTimes) {
      let logText = "";
      creditPrintTimes.forEach((time: any) => {
        logText = logText + time + "\r\n";
      });
      return logText;
    }
  };

  // 功能10: 删除客户所有贷款
  // API: DELETE /mortgageLoan/deleteByLeadId/{leadId}
  // Controller: MortgageLoanController.deleteByLeadId
  const deleteMortgageLoanByLeadId = (row: any, rows: any) => {
    if (rows && rows.length > 1) {
      Toast.info("只能选择一个客户");
      return;
    } else if (rows && rows.length == 0) {
      //如果未选择客户
      Toast.info("请选择一个客户来操作");
      return;
    }
    Modal.confirm({
      title: "是否确认删除？该操作会删除客户所有的贷款和所有的还款计划。",
      content: "",
      onOk: async () => {
        try {
          await apiClient.request<boolean>(
            "/mortgageLoan/deleteByLeadId/" + rows[0].leadId,
            "DELETE"
          );
          Toast.info("删除成功");

          crudApi?.refresh();
        } catch (e) {}
      },
    });
  };

  // 删除按钮动作定义
  const deleteAction: CrudAction = {
    name: "删除",
    type: "danger",
    action: deleteMortgageLoanByLeadId,
  };

  // 生成还款计划 (基于已有贷款自动生成)
  // API: POST /mortgageLoan/makeRepaymentPlan/{id}  (通过 apiClient.makeRepaymentPlan 调用)
  const makeRepaymentPlan = (row: any) => {
    Modal.confirm({
      title: "是否确认生成还款计划。",
      content: "",
      onOk: async () => {
        try {
          await apiClient.makeRepaymentPlan(row.id);
          Toast.info("生成成功");

          crudApi?.refresh();
        } catch (e) {}
      },
    });
  };

  const makePlanAction: CrudAction = {
    name: "生成还款计划",
    action: makeRepaymentPlan,
  };

  // 功能12: 打开贷款详情页面
  // 跳转到新窗口 /#/newleadLoan，传入客户ID和姓名
  // 对应二级页面 indexMortgageLoan.tsx (entityKey: mortgageLoan/listGroupPlatform)
  const openMortgageLoanModal = async (leadId: number, leadName: string) => {
    //setLeadId(leadId);
    //setMortgageLoanShow(true);
    //打开客户贷款
    const w = window.open("about:blank");
    if (w != null) {
      //获取表格data的id列表
      const data = {
        id: leadId,
        name: leadName,
      };
      w.location.href =
        "/#/newleadLoan?data=" + encodeURIComponent(JSON.stringify(data));
    }
  };

  // 功能11: 打开还款计划弹窗
  // 弹窗内嵌 RepaymentPlan 组件，传入 leadId 和 paidType 过滤条件
  const openRepaymentPlanModal = async (leadId: number, paidType: string) => {
    setLeadId(leadId);
    setPaidType(paidType);
    setPlanShow(true);
  };

  const handleSaveLoanButtonClick = (a: any, rows: any) => {
    if (rows && rows.length > 1) {
      Toast.info("只能选择一个客户");
      return;
    } else if (rows && rows.length == 1) {
      apiClient.getLead(rows[0].leadId).then((resp) => {
        setPreselectedLead(resp);
        setShowAddLoanModal(true);
      });
    } else {
      setPreselectedLead(undefined);
      setShowAddLoanModal(true);
    }
  };

  const actions: CrudAction[] = [];
  const addLoanAction: CrudAction = {
    name: "新增贷款",
    type: "warning",
    action: handleSaveLoanButtonClick,
  };



  // 功能4: 释放客户
  // 打开新窗口 /#/releaseLead，传入客户ID和姓名
  // 新窗口中使用 ReleaseLeadPage 组件完成释放操作
   const handleSaveLeadInfoButtonClick = (a: any, rows: any) => {
    if (rows && rows.length > 1) {
      Toast.info("只能选择一个客户");
      return;
    } else if (rows && rows.length == 1) {
      //如果选中一个客户
      // setSelectedLeads(rows);
      // setLeadId(rows[0].id);
      // apiClient.getLead(rows[0].id).then((resp) => {
      //     if (resp) {
      //         setLead(resp);
      //         setShowLeadInfoModal(true);

      //     } else {

      //         Toast.info("客户不存在");
      //     }
      // });

      const w = window.open("about:blank");
      if (w != null) {
        //获取表格data的id列表
        const data = {
          id: rows[0].id,
          name: rows[0].leadName,
        };
        w.location.href =
          "/#/releaseLead?data=" +
          encodeURIComponent(JSON.stringify(data));
      }
    } else {
      //如果未选择客户
      Toast.info("请选择一个客户来操作");
      return;
    }
  };


  // 释放客户动作定义
  const releaseLeadAction: CrudAction = {
    name: "释放客户",
    type: "warning",
    action: handleSaveLeadInfoButtonClick,
  };

  const handleSaveLeadInfoClick = async () => {
    crudApi?.refresh();
    setShowLeadInfoModal(false);
  };

  // 功能5: 坏账标记
  // API: POST /mortgageLoan/updateLeadLoanStatus
  // Controller: MortgageLoanController.updateLeadLoanStatus
  // 参数: { leadId, loanStatus: "BAD_DEPT" }
  const updateBadDeptButtonClick = (a: any, rows: any) => {
    if (rows && rows.length > 1) {
      Toast.info("只能选择一个客户");
      return;
    } else if (rows && rows.length == 0) {
      //如果未选择客户
      Toast.info("请选择一个客户来操作");
      return;
    }

    Modal.confirm({
      title: "是否确认修改客户为坏账?",
      content: "",
      onOk: async () => {
        try {
          await apiClient.request(
            "/mortgageLoan/updateLeadLoanStatus",
            "POST",
            undefined,
            { leadId: rows[0].leadId, loanStatus: "BAD_DEPT" }
          );
          Toast.info("修改客户为坏账成功");
          crudApi?.refresh();
        } catch (e) {}
      },
    });
  };

  // 坏账标记动作定义
  const updateBadDeptAction: CrudAction = {
    name: "坏账",
    type: "danger",
    action: updateBadDeptButtonClick,
  };

  // 功能6: 利率设置提交
  // API: POST /mortgageLoan/saveInterest
  // Controller: MortgageLoanController.saveInterest
  // 参数: { interest(日利率), borrowInterest(借款日利率), postingInterest(过账利率), leadId }
  const handleAddInterestClick = async () => {
    try {
      await addInterestFormApi!.validate();
      let values = addInterestFormApi!.getValues();
      console.log(values);

      setAddQuerySaving(true);

      let params = {
        interest: values.interest,
        borrowInterest: values.borrowInterest,
        postingInterest: values.postingInterest,
        leadId: selectedLead.leadId,
      };

      await apiClient.request(
        "/mortgageLoan/saveInterest",
        "POST",
        null,
        params
      );
      crudApi?.refresh();
      setAddQuerySaving(false);
      setShowAddInterestModal(false);
    } catch (e) {
      setAddQuerySaving(false);
    }
  };

  // 利率设置按钮点击处理，选中客户后打开利率设置弹窗
  const addInterestButtonClick = (row: any, rows: any) => {
    if (rows && rows.length > 1) {
      Toast.info("只能选择一个客户");
      return;
    } else if (rows && rows.length == 0) {
      //如果未选择客户
      Toast.info("请选择一个客户来操作");
      return;
    }
    setSelectedLead({ leadId: rows[0].leadId, interest: rows[0].interest, borrowInterest: rows[0].borrowInterest, postingInterest: rows[0].postingInterest });
    setShowAddInterestModal(true);
  };

  // 利率设置动作定义
  const addInterestAction: CrudAction = {
    name: "利率",
    type: "primary",
    icon: <IconMonitorStroked />,
    action: addInterestButtonClick,
  };

  // 页面加载时获取团队成员（销售和按揭专员）树形选项，用于新增贷款时选择出款人
  useEffect(() => {
    //获取所有销售和按揭专员
    apiClient
      .getTeamMemberByDataScopeAsOpts("payment")
      .then((opts) => setTeamMembersTree(opts));
    return () => {
      console.log("离开页面------------");
    };
  }, []);

  // 功能7: 查询日期管理提交
  // API: POST /mortgageLoan/saveAndUpdateExtra (optType=queryTime)
  // Controller: MortgageLoanController.saveAndUpdateExtra
  // 参数: { queryTimes(日期|机构|原因数组), leadId, optType: "queryTime" }
  const handleAddQueryTimeClick = async () => {
    try {
      await addQueryFormApi!.validate();
      let values = addQueryFormApi!.getValues();
      console.log(values);

      let queryTimeArr = [];
      if (values.queryTimes && values.queryTimes.length > 0) {
        queryTimeArr = handleArrayTimes(values.queryTimes);
        if (queryTimeArr.length == 0) {
          Toast.info("查询日期校验：请选择今天之前的日期");
          return false;
        }
        //前面拼接
        let creditQueryTimeArrNew = [];
        values.queryTimes.forEach((item: any) => {
          creditQueryTimeArrNew.push(formatDate(item.queryTime) + '|' + item.queryOrg + "|" +item.queryReason );
        });
        queryTimeArr = creditQueryTimeArrNew;
      }
      
      setAddQuerySaving(true);

      let params = {
        queryTimes: queryTimeArr,
        leadId: selectedLead.leadId,
        optType: "queryTime",
      };

      await apiClient.request(
        "/mortgageLoan/saveAndUpdateExtra",
        "POST",
        null,
        params
      );
      crudApi?.refresh();
      setAddQuerySaving(false);
      setShowAddQueryModal(false);
    } catch (e) {
      setAddQuerySaving(false);
    }
  };

  // 工具函数: 格式化查询日期数组并校验日期不能大于今天
  const handleArrayTimes = (values: any) => {
    //格式化values日期数组的所有日期，赋值给新数组
    let newDateArr: any[] = [];
    if (values) {
      values.forEach((item: any) => {
        if (!item.queryTime || typeof item.queryTime == "string") {
          //截取字符串只保留日期部分
          let newitem = item.queryTime.substring(0, 10);
           newDateArr.push(newitem);
        } else {
          let newitem =  formatDate(item.queryTime);
           newDateArr.push(newitem);
        }
       
      });
    }
    console.log(newDateArr);
    let validateDateResult = true;
    //校验values日期数组的所有日期不能大于今天
    newDateArr.forEach((item: any) => {
      if (item > nowDateStr) {
        validateDateResult = false;
        return [];
      }
    });
    return newDateArr;
  };

  // 工具函数: 格式化征信打印日期数组并校验日期不能大于今天
    const handleArrayCreditPrintTimes = (values: any) => {
    //格式化values日期数组的所有日期，赋值给新数组
    let newDateArr: any[] = [];
    if (values) {
      values.forEach((item: any) => {
        if (!item.creditPrintTime || typeof item.creditPrintTime == "string") {
          //截取字符串只保留日期部分
          let newitem = item.creditPrintTime.substring(0, 10);
           newDateArr.push(newitem);
        } else {
          let newitem =  formatDate(item.creditPrintTime);
           newDateArr.push(newitem);
        }
       
      });
    }
    console.log(newDateArr);
    let validateDateResult = true;
    //校验values日期数组的所有日期不能大于今天
    newDateArr.forEach((item: any) => {
      if (item > nowDateStr) {
        validateDateResult = false;
        return [];
      }
    });
    return newDateArr;
  };


  // 查询日期按钮点击处理，选中客户后打开查询日期管理弹窗
  const addQueryButtonClick = (row: any, rows: any) => {
    if (rows && rows.length > 1) {
      Toast.info("只能选择一个客户");
      return;
    } else if (rows && rows.length == 0) {
      //如果未选择客户
      Toast.info("请选择一个客户来操作");
      return;
    }
    setSelectedLead({ leadId: rows[0].leadId, loanAt: rows[0].loanAt });
    let queryTimeArr = rows[0].queryTimes;
    let queryTimesNewArr = [];
    if(queryTimeArr&&queryTimeArr.length>0){
      for(let i=0;i<queryTimeArr.length;i++){ 
        if(queryTimeArr[i].includes("|")){
           let arr = queryTimeArr[i].split("|");
           queryTimesNewArr.push({queryTime: arr[0], queryOrg: arr[1], queryReason: arr[2]}); 
        }else {
           queryTimesNewArr.push({queryTime: queryTimeArr[i], queryOrg: "", queryReason: ""});
        }
        
      }
       
    }
    setQueryTimes(queryTimesNewArr);
 
    setShowAddQueryModal(true);
  };

  // 查询日期动作定义
  const addQueryAction: CrudAction = {
    name: "查询日期",
    type: "secondary",
    icon: <IconCalendarClock />,
    action: addQueryButtonClick,
  };

  
  // 功能8: 征信打印日期管理提交
  // API: POST /mortgageLoan/saveAndUpdateExtra (optType=creditPrintTime)
  // Controller: MortgageLoanController.saveAndUpdateExtra
  // 参数: { creditPrintTimes(客户经理|日期数组), leadId, optType: "creditPrintTime" }
  const handleAddCreditTimeClick = async () => {
    try {
      await addCreditFormApi!.validate();
      let values = addCreditFormApi!.getValues();
      console.log(values);

      let creditPrintTimeArr = [];
      if (values.creditPrintTimes && values.creditPrintTimes.length > 0) {
        creditPrintTimeArr = handleArrayCreditPrintTimes(values.creditPrintTimes);
        if (creditPrintTimeArr.length == 0) {
          Toast.info("征信打印日期校验：请选择今天之前的日期");
          return false;
        }
        //前面拼接上客户经理
        let creditPrintTimeArrNew = [];
        values.creditPrintTimes.forEach((item: any) => {
          creditPrintTimeArrNew.push(item.saleName + "|" + formatDate(item.creditPrintTime));
        });
        creditPrintTimeArr = creditPrintTimeArrNew;
      }else{
        Toast.info("请选择征信打印日期");
        return false;

      }
      console.log(creditPrintTimeArr);

      setAddQuerySaving(true);

      let params = {
        creditPrintTimes: creditPrintTimeArr,
        leadId: selectedLead.leadId,
        optType: "creditPrintTime",
      };

      await apiClient.request(
        "/mortgageLoan/saveAndUpdateExtra",
        "POST",
        null,
        params
      );
      crudApi?.refresh();
      setAddQuerySaving(false);
      setShowAddCreditModal(false);
    } catch (e) {
      setAddQuerySaving(false);
    }
  };


  // 征信打印日期按钮点击处理，选中客户后打开征信打印日期管理弹窗
  const addCreditButtonClick = (row: any, rows: any) => {
    if (rows && rows.length > 1) {
      Toast.info("只能选择一个客户");
      return;
    } else if (rows && rows.length == 0) {
      //如果未选择客户
      Toast.info("请选择一个客户来操作");
      return;
    }
    setSelectedLead({ leadId: rows[0].leadId, loanAt: rows[0].loanAt });
    let creditArr = rows[0].creditPrintTimes;
    let creditPrintTimesNew = [];
    if(creditArr&&creditArr.length>0){
      for(let i=0;i<creditArr.length;i++){ 
         let arr = creditArr[i].split("|");
        
        creditPrintTimesNew.push({saleName: arr[0], creditPrintTime: arr[1]}); 
      }
       
    }
    setCreditPrintTimes(creditPrintTimesNew);
    console.log("creditPrintTimes:", creditPrintTimes);
    setShowAddCreditModal(true);
  };

  // 征信打印日期动作定义
  const addCreditAction: CrudAction = {
    name: "征信打印日期",
    type: "secondary",
    icon: <IconCalendarClock />,
    action: addCreditButtonClick,
  };

  // 功能9: 客户信息更新提交（接单日期 + 业务属性）
  // API: POST /mortgageLoan/saveAndUpdateExtra (optType=loanAt)
  // Controller: MortgageLoanController.saveAndUpdateExtra
  // 参数: { leadId, loanAt(接单日期), loanProperty(业务属性), optType: "loanAt" }
  const handleLoanAtTimeClick = async () => {
    try {
      await loanAtFormApi!.validate();
      let values = loanAtFormApi!.getValues();
      console.log(values);

      setAddQuerySaving(true);

      let params = {
        leadId: selectedLead.leadId,
        loanAt: formatDate(values.loanAt),
        loanProperty: values.loanProperty,
        optType: "loanAt",
      };

      await apiClient.request(
        "/mortgageLoan/saveAndUpdateExtra",
        "POST",
        null,
        params
      );
      crudApi?.refresh();
      setAddQuerySaving(false);
      setShowLoanAtModal(false);
    } catch (e) {
      setAddQuerySaving(false);
    }
  };


  // 修改客户按钮点击处理，选中客户后打开客户信息修改弹窗
  const loanAtButtonClick = (row: any, rows: any) => {
    if (rows && rows.length > 1) {
      Toast.info("只能选择一个客户");
      return;
    } else if (rows && rows.length == 0) {
      //如果未选择客户
      Toast.info("请选择一个客户来操作");
      return;
    }
    setSelectedLead({ leadId: rows[0].leadId, loanAt: rows[0].loanAt, loanProperty: rows[0].loanProperty });
    setShowLoanAtModal(true);
  };

  // 修改客户动作定义
  const loanAtAction: CrudAction = {
    name: "修改客户",
    type: "warning",
    icon: <IconCalendarClock />,
    action: loanAtButtonClick,
  };

  let nowDate = new Date();
  let nowDateStr = formatDateTime(nowDate);

  // 打开客户详情页面，在新窗口中跳转到 /#/newlead 查看客户信息
  const detailAction = (a: any) => {
    const w = window.open("about:blank");
    let queryParams = {
      ...crudApi?.getQueryParams(),
      type: "all",
    };
    if (w != null) {
      //获取表格data的id列表
      const ids = crudApi?.getData()?.map((i) => i.leadId);
      const data = {
        id: a.leadId,
        ids: ids,
        viewMode: true,
        visitMode: false,
        leadFrom: "report",
        queryParams: queryParams,
      };
      w.location.href =
        "/#/leadDetailNew?data=" + encodeURIComponent(JSON.stringify(data));
    }
  };

  useEffect(() => {
    //刷新统计
    initStatCountData();
  }, [statDataObj]);

  // 功能2: 查询统计数据（顶部统计栏）
  // API: GET /mortgageLoan/leadListSum
  // Controller: MortgageLoanController.leadListSum
  const queryStatCount = async (data: any) => {
    let params = {
      ...data,
    };
    console.log("统计报表查询参数：", params);
    apiClient.request("/mortgageLoan/leadListSum", "GET", data).then((resp) => {
      setStatDataObj(resp.data);
    });
  };

  // 将统计API返回的数据转换为 Descriptions 组件所需的格式
  // 包含: 客户数、签约金额、贷款金额、支出合计、代还金额、借款金额等
  const initStatCountData = async () => {
    console.log("统计报表返回数据：", statDataObj);
    if (!statDataObj) {
      return;
    }

    const data = [
      { key: "", value: "汇总" },
      {
        key: "客户数",
        value: statDataObj.leadCount,
      },
      {
        key: "签约金额",
        value: formatAmountZhCn(statDataObj.totalContractAmount),
      },
      {
        key: "借贷金额",
        value: formatAmountZhCn(statDataObj.totalAmount),
      },
      
      {
        key: "信用卡代过账",
        value: formatAmountZhCn(statDataObj.totalHelpPostingAmount),
      },
      {
                      key: (
                          <Tooltip
                              style={{ maxWidth: 400 }}
                              content={"出款金额 = 贷款代还 + 信用卡代还 + 个人借款"}
                          >出款金额
                              <IconHelpCircle
                                  style={{
                                      color: "#E91E63",
                                  }}
                              />
                          </Tooltip>
                      ),
                      value: formatAmountZhCn(statDataObj.totalHelpPaidAmount + statDataObj.totalCardHelpPaidAmount + statDataObj.totalBorrowAmount)
      
                  },
      {
        key: "个人借款金额",
        value: formatAmountZhCn(statDataObj.totalBorrowAmount),
      },
      {
        key: "个人借款已还",
        value: formatAmountZhCn(statDataObj.totalReturnAmount),
      },
      {
        key: (
          <Tooltip
            style={{ maxWidth: 400 }}
            content={
              "支出合计 = 贷款代还 + 信用卡代还  + 个人借款 - 个人借款已还"
            }
          >
            支出合计
            <IconHelpCircle
              style={{
                color: "#E91E63",
              }}
            />
          </Tooltip>
        ),
        value: (
          <span
            style={{
              color: "#E91E63",
            }}
          >
            {formatAmountZhCn(statDataObj.totalExpense)}
          </span>
        ),
      },
      {
        key: "查询异常客户数",
        value: (
          <Button
            theme="borderless"
            type="primary"
            onClick={() =>
              handleStatNumClick("queryTimeNumGtOne", crudApi, filterFormApi)
            }
          >
            {statDataObj.queryNumsGtOne}
          </Button>
        ),
      },
      {
        key: "",
        value: "今日",
      },
      {
        key: "贷款待还",
        value: formatAmountZhCn(statDataObj.dayMortgageOneTermAmount),
      },
      {
        key: "贷款已还",
        value: formatAmountZhCn(statDataObj.dayMortgagePaidAmount),
      },
      {
        key: "借款待还",
        value: formatAmountZhCn(statDataObj.dayBorrowOneTermAmount),
      },
      {
        key: "借款已还",
        value: formatAmountZhCn(statDataObj.dayBorrowPaidAmount),
      },
      {
        key: "",
        value: "本月",
      },
      {
        key: "贷款待还",
        value: formatAmountZhCn(statDataObj.monthMortgageOneTermAmount),
      },
      {
        key: "贷款已还",
        value: formatAmountZhCn(statDataObj.monthMortgagePaidAmount),
      },
      {
        key: "借款待还",
        value: formatAmountZhCn(statDataObj.monthBorrowOneTermAmount),
      },
      {
        key: "借款已还",
        value: formatAmountZhCn(statDataObj.monthBorrowPaidAmount),
      },
    ];
    setStatData(data);
  };

  // 统计数字点击处理：设置筛选条件并刷新列表（如点击"查询异常客户数"自动筛选）
  const handleStatNumClick = async (
    statType: string,
    rsApi?: CrudApi,
    filterFormApi1?: FormApi
  ) => {
    filterFormApi1?.setValue("statType", statType);
    rsApi?.refresh();
  };

  // 统计项下拉选项定义（用于筛选列中的统计项筛选）
  const getMortgageStatTypeItemOpt = (): CrudOption[] => {
    let items = [
      {
        label: "查询异常客户数",
        value: "queryTimeNumGtOne",
        key: "0",
      },
    ];
    return items;
  };


  // 渲染顶部统计栏 Descriptions 组件
  const listSumStat = () => {
    const style = {
      boxShadow: "var(--semi-shadow-elevated)",
      backgroundColor: "var(--semi-color-bg-2)",
      borderRadius: "4px",
      padding: "5px",
      margin: "auto",
    };
    return (
      <div style={{ display: "flex", width: "100%", margin: "5px", alignItems: "center" }}>
        <Popover
          content={renderStatDetailContent(statDataObj)}
          trigger="hover"
          position="bottomLeft"
          showArrow
        >
          <a style={{ marginRight: 12, whiteSpace: 'nowrap', color: 'var(--semi-color-link)', cursor: 'pointer' }}><IconBarChartHStroked />统计详情</a>
        </Popover>
        <Descriptions data={statData} row align={"center"} style={style} />
      </div>
    );
  };


  // 按钮权限控制: 只有 agent/agent_manager/op_manager/monitor/root 角色才能看到操作按钮
  //------------------------------------------------按钮控制------------------------------------------------------------------
  if (
    role == "agent" ||
    role == "agent_manager" ||
    role == "op_manager" ||
    role == "monitor" ||
    role == "root"
  ) {
    actions.push(addLoanAction);
    actions.push(releaseLeadAction);
    actions.push(updateBadDeptAction);
    actions.push(addInterestAction);
    actions.push(addQueryAction);
    actions.push(addCreditAction);
    actions.push(loanAtAction);
    actions.push(deleteAction);
  }

  return (
    <>
      <AddLoanModal
        visible={showAddLoanModal}
        onClose={() => { setShowAddLoanModal(false); setPreselectedLead(undefined); }}
        onSuccess={() => crudApi?.refresh()}
        lead={preselectedLead}
        teamMembersTree={teamMembersTree}
      />

      {/* <Modal icon={<IconModalStroked size={“extra-large”} style={{color: 'blue'}}/>} title={“贷款信息：”+leadId}
               fullScreen={true}
               headerStyle={{
                   flexShrink: 0, // 关键属性 2：固定标题
                   borderBottom: '1px solid var(--semi-color-border)'
               }}
               bodyStyle={{
                   overflow: 'auto', // 关键属性 3：启用内容滚动
                   padding: '5px 5px',
                   flex: 1
               }}
               footer={null}
               hasCancel={false} onCancel={() => setMortgageLoanShow(false)} onOk={() => setMortgageLoanShow(false)}
               visible={mortgageLoanShow}>
            <div><IndexMortgageLoan leadId={leadId}/></div>
        </Modal> */}
      <Modal
        icon={
          <IconModalStroked size={"extra-large"} style={{ color: "blue" }} />
        }
        title={"还款计划"}
        fullScreen={true}
        headerStyle={{
          flexShrink: 0, // 关键属性 2：固定标题
          borderBottom: "1px solid var(--semi-color-border)",
        }}
        bodyStyle={{
          overflow: "auto", // 关键属性 3：启用内容滚动
          flex: 1,
        }}
        footer={null}
        hasCancel={false}
        onCancel={() => {
            setPlanShow(false);
            crudApi?.refresh();
          }
        }
        onOk={() => {
            setPlanShow(false);
            crudApi?.refresh();
          }}
        visible={planShow}
      >
        <div>
          <RepaymentPlan leadId={leadId} loanId={loanId} paidType={paidType} />
        </div>
      </Modal>
      <Modal
        icon={
          <IconModalStroked size={"extra-large"} style={{ color: "blue" }} />
        }
        title={"出款明细"}
        fullScreen={true}
        headerStyle={{
          flexShrink: 0,
          borderBottom: "1px solid var(--semi-color-border)",
        }}
        bodyStyle={{
          overflow: "auto",
          flex: 1,
        }}
        footer={null}
        hasCancel={false}
        onCancel={() => setOutMoneyPlanShow(false)}
        onOk={() => setOutMoneyPlanShow(false)}
        visible={outMoneyPlanShow}
      >
        <div>
          <OutMoneyPlan leadId={leadId} />
        </div>
      </Modal>
      <Modal
        icon={
          <IconModalStroked size={"extra-large"} style={{ color: "blue" }} />
        }
        style={{ width: 1000, height: 600 }}
        headerStyle={{
          flexShrink: 0, // 关键属性 2：固定标题
          borderBottom: "1px solid var(--semi-color-border)",
        }}
        bodyStyle={{
          overflow: "auto", // 关键属性 3：启用内容滚动
          flex: 1,
        }}
        title="查询日期"
        visible={showAddQueryModal}
        okText="保存"
        confirmLoading={addQuerySaving}
        onOk={handleAddQueryTimeClick}
        onCancel={() => setShowAddQueryModal(false)}
      >
        <Form getFormApi={(formApi) => setAddQueryFormApi(formApi)}>
        
         
            <ArrayField field="queryTimes" initValue={queryTimes}>
              {({ add, arrayFields, addWithInitValue }) => (
                <React.Fragment>
                  <Button
                    icon={<IconPlusCircle />}
                    onClick={() => {
                      addWithInitValue(nowDateStr);
                    }}
                    style={{ marginLeft: 8 }}
                  >
                    新增
                  </Button>
                  {arrayFields.map(({ field, key, remove }, i) => (
                    <div key={key} style={{ width: 900, display: "flex" }}>
                      <Row gutter={8}>
                      <RowCol span={6}>
                      <Form.DatePicker
                        rules={[{ required: true, message: "请选择查询日期" }]}
                        style={{ width: 150 }}
                        type="date"
                        format={"yyy-MM-dd"}
                        noLabel={true}
                        field={`${field}[queryTime]`}
                      />
                      </RowCol>
                       <RowCol span={8}>
                          <Form.Input
                          rules={[{ required: true, message: "请填写查询机构" }]}
                          placeholder={"请填写查询机构" }
                          style={{ width: 280 }}
                          noLabel={true}
                          field={`${field}[queryOrg]`}
                          />
                       </RowCol>
                       <RowCol span={10}>
                          <Form.Input
                          rules={[{ required: true, message: "请填写查询原因" }]}
                          placeholder={"请填写查询原因" }
                          style={{ width: 260 }}
                          noLabel={true}
                          field={`${field}[queryReason]`}
                          />
                      </RowCol>
                      
                      </Row>
                      <Button
                        type="danger"
                        theme="borderless"
                        icon={<IconMinusCircle />}
                        onClick={remove}
                        style={{ margin: 12 }}
                      />
                    </div>
                  ))}
                </React.Fragment>
              )}
            </ArrayField>
       

        </Form>
      </Modal>
      <Modal
        icon={
          <IconModalStroked size={"extra-large"} style={{ color: "blue" }} />
        }
        style={{ width: 700, height: 600 }}
        headerStyle={{
          flexShrink: 0, // 关键属性 2：固定标题
          borderBottom: "1px solid var(--semi-color-border)",
        }}
        bodyStyle={{
          overflow: "auto", // 关键属性 3：启用内容滚动
          flex: 1,
        }}
        title="修改客户信息"
        visible={showLoanAtModal}
        okText="保存"
        confirmLoading={addQuerySaving}
        onOk={handleLoanAtTimeClick}
        onCancel={() => setShowLoanAtModal(false)}
      >
        <Form getFormApi={(formApi) => setLoanAtFormApi(formApi)}>
          <Form.DatePicker
            rules={[{ required: true, message: "请填写" }]}
            key="loanAt"
            label="接单日期"
            style={{ width: 200 }}
            field="loanAt"
            initValue={selectedLead.loanAt}
          />
          <Form.Select  field="loanProperty" label="业务属性" showClear style={{ width: 200 }} initValue={selectedLead.loanProperty}>
              <Form.Select.Option value="债务优化">债务优化</Form.Select.Option>
              <Form.Select.Option value="企业陪跑">企业陪跑</Form.Select.Option>
         </Form.Select>


        </Form>
      </Modal>
      <Modal
        icon={
          <IconModalStroked size={"extra-large"} style={{ color: "blue" }} />
        }
        style={{ width: 900, height: 600 }}
        headerStyle={{
          flexShrink: 0, // 关键属性 2：固定标题
          borderBottom: "1px solid var(--semi-color-border)",
        }}
        bodyStyle={{
          overflow: "auto", // 关键属性 3：启用内容滚动
          flex: 1,
        }}
        title="征信打印日期"
        visible={showAddCreditModal}
        okText="保存"
        confirmLoading={addQuerySaving}
        onOk={handleAddCreditTimeClick}
        onCancel={() => setShowAddCreditModal(false)}
      >
        <Form getFormApi={(formApi) => setAddCreditFormApi(formApi)}>

            <ArrayField field="creditPrintTimes" initValue={creditPrintTimes}>
              {({ add, arrayFields, addWithInitValue }) => (
                <React.Fragment>
                  <Button
                    icon={<IconPlusCircle />}
                    onClick={() => {
                      addWithInitValue(nowDateStr);
                    }}
                    style={{ marginLeft: 8 }}
                  >
                    新增
                  </Button>
                  {arrayFields.map(({ field, key, remove }, i) => (
                    <div key={key} style={{ width: 800, display: "flex" }}>
                    <Row>
                       <RowCol span={12}>
                          <Form.Input
                          rules={[{ required: true, message: "请填写客户经理姓名" }]}
                          placeholder={"请填写客户经理姓名" }
                          style={{ width: 350 }}
                          noLabel={true}
                          field={`${field}[saleName]`}
                          />
                      </RowCol>
                      <RowCol span={12}>
                       <Form.DatePicker
                        rules={[
                          { required: true, message: "请选择征信打印日期" },
                        ]}
                        placeholder={"请选择征信打印日期"}
                        style={{ width: 400 }}
                        type="date"
                        format={"yyy-MM-dd"}
                        noLabel={true}
                        field={`${field}[creditPrintTime]`}
                      />
                      </RowCol>
                      </Row>
                      <Button
                        type="danger"
                        theme="borderless"
                        icon={<IconMinusCircle />}
                        onClick={remove}
                        style={{ margin: 12 }}
                      />
                    </div>
                  ))}
                </React.Fragment>
              )}
            </ArrayField>
          
        </Form>
      </Modal>
      <Modal
        icon={
          <IconModalStroked size={"extra-large"} style={{ color: "blue" }} />
        }
        style={{ width: 600, height: 400 }}
        headerStyle={{
          flexShrink: 0, // 关键属性 2：固定标题
          borderBottom: "1px solid var(--semi-color-border)",
        }}
        bodyStyle={{
          overflow: "auto", // 关键属性 3：启用内容滚动
          flex: 1,
        }}
        title="设置日利率"
        visible={showAddInterestModal}
        okText="保存"
        confirmLoading={addQuerySaving}
        onOk={handleAddInterestClick}
        onCancel={() => setShowAddInterestModal(false)}
      >
        <Form getFormApi={(formApi) => setAddInterestFormApi(formApi)}>
          <Form.InputNumber
            rules={[{ required: true, message: "请填写" }]}
            key="interest"
            label="日利率"
            style={{ width: 200 }}
            field="interest"
            initValue={selectedLead.interest}
          />
          <Form.InputNumber
            rules={[{ required: true, message: "请填写" }]}
            key="borrowInterest"
            label="借款日利率"
            style={{ width: 200 }}
            field="borrowInterest"
            initValue={selectedLead.borrowInterest}
          />
          <Form.InputNumber
            rules={[{ required: true, message: "请填写" }]}
            key="postingInterest"
            label="过账利率"
            style={{ width: 200 }}
            field="postingInterest"
            initValue={selectedLead.postingInterest}
          />
        </Form>
      </Modal>

      <Row>
        <RowCol span={24}>{listSumStat()}</RowCol>
      </Row>
      <Crud
        getCrudApi={(crudApi) => {
          setCrudApi(crudApi);
        }}
        getFilterFormApi={(crudApi, api) => {
          setFilterFormApi(api);
        }}
        canUpdate={false}
        canCreate={false}
        canDelete={false}
        name="按揭还款"
        entityKey="mortgageLoan/leadList"
        pageSize={50}
        actions={actions}
        select={true}
        rowActionWidth={0}
        fetchDataAfterMethod={queryStatCount}
        getRowActions={(a) => {
          //let actions = [];

          return [];
        }}
        cols={cols}
      />
    </>
  );
}
